module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Frontmatter"
    }
  }, [_c('p', {
    staticClass: "fm-para1"
  }, [_vm._v("By the same author"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page1"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('i', [_vm._v("The Scapegoat: The Life and Tragedy of a Fighting")]), _c('br'), _c('i', [_vm._v("Admiral and Churchill’s role in his death")]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('i', [_vm._v("The Coward? The Rise and Fall of the Silver King")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('i', [_vm._v("Formidable")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.steverdunn.com",
      "target": "_blank"
    }
  }, [_vm._v("www.steverdunn.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2acfb82b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Frontmatter.vue
// module id = 60
// module chunks = 0